/** What the home screen sends for the match, from the player's picks. Pure. */

/** Null plays by length; a goal the game does not offer rounds to its top one (none for King: by length). */
export function roundGoal(goal: number | null, goals: readonly number[]): number | null {
  if (goal === null || goals.includes(goal)) return goal;
  return goals[goals.length - 1] ?? null;
}

/** The hands a table will play: the player's pick when the game has lengths of its own, else the table's. */
export function pickLength(
  lengths: readonly number[] | null,
  picked: number | null,
  tableLength: number,
): number {
  if (lengths === null) return tableLength;
  return picked !== null && lengths.includes(picked) ? picked : (lengths[0] ?? tableLength);
}
